import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import TextInput from '../../generic/fields/TextInput';
import { hashToUri } from '../../../helpers/util';

class Graphic extends Component {
  render() {
    const { userEvent, onChange } = this.props
    let style = {
      display: 'block',
      // border: this.props.public ? 'none' : '1px solid #d8d8d8',
      // margin: '0 auto',
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      // maxHeight: '60vh',
    }
    const params = {
      food1: userEvent.food1 || '',
      food2: userEvent.food2 || '',
      topic: userEvent.topic || '',
      image: userEvent.invitation_logo || '',
    }
    return (
      <React.Fragment>
        <img src={`/api/image?${hashToUri(params)}`} width="800" height="" height="400" border="0" style={style} alt="" />
      </React.Fragment>
    )
  }
}

export default Graphic
